<mat-card
	*ngFor="let row of termsAndConditionsDocumentsHistory, let i = index"
	(click)="onTermsAndAgreementsClick(row, i)"
>
	<mat-card-header class="obg-m-sm-terms-and-conditions-history-header">
		<mat-card-title>{{ row.majorVersion }}.{{ row.minorVersion }}</mat-card-title>
		<ng-container *ngIf="jurisdiction === 'COGA'">
			<i
				class="obg-m-sm-terms-and-conditions-history-header-icon ico-arrow-down"
				*ngIf="isDownloadLatestAcceptedContentEnabled && (i === 0); else viewButtonTemplate"
			>
			</i>

			<ng-template #viewButtonTemplate>
				<i class="obg-m-sm-terms-and-conditions-history-header-icon ico-show"></i>
			</ng-template>
		</ng-container>
	</mat-card-header>

	<mat-card-content>
		<div>
			<small>{{ 'terms-and-conditions.history-issued-date' | translate }}</small>
			<span>{{ row.effectiveFrom | date: 'dd-MM-YYYY hh:mm:ss' }}</span>
		</div>
		<div>
			<small>{{ 'terms-and-conditions.history-accepted-date' | translate }}</small>
			<span>{{ row.acceptedAt | date: 'dd-MM-YYYY hh:mm:ss' }}</span>
		</div>
	</mat-card-content>
</mat-card>
